module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-1-f30142abf4ea62723b91c026f0b5048b.jpg";